// extracted by mini-css-extract-plugin
export default {"container":"DnkTGW","bgClouds":"aZtok6","bgSky":"bODWpW"};